import PaymentTag from './PaymentTag';

export default PaymentTag;
